import React from "react";
import { Box } from "grommet/es6";
import styled from "styled-components";

export const Spacer = styled.div`
  height: 120px;
`;

const AppBar = (props) => (
  <Box
    tag="header"
    direction="row"
    align="center"
    justify="between"
    background="brand"
    pad={{ left: "medium", right: "small", vertical: "small" }}
    elevation="medium"
    style={{ zIndex: "1", position: "absolute", width: "100%", margin: 0 }}
    {...props}
  />
);

export default AppBar;
